import afterSibling from './afterSibling'
import alphanumeric from './alphanumeric'
import cardNumber from './cardNumber'
import cnpj from './cnpj'
import cpf from './cpf'
import cpfOrCnpj from './cpfOrCnpj'
import domain from './domain'
import equalsSibling from './equalsSibling'
import fileUpload from './fileUpload'
import notInPast from './notInPast'
import phone from './phone'
import protocol from './protocol'
import richTextRequired from './richTextRequired'
import strongPassword from './strongPassword'

export default [
  alphanumeric,
  cardNumber,
  cnpj,
  cpf,
  cpfOrCnpj,
  domain,
  equalsSibling,
  fileUpload,
  phone,
  protocol,
  richTextRequired,
  strongPassword,
  notInPast,
  afterSibling,
]
